export default (function () {
  return !!window.navigator.maxTouchPoints || 'ontouchstart' in document;
});